import { Observable } from 'rxjs/Observable';
import { BaseCondition } from "./base.condition";
import { NotificationService } from '../../services';
import { ConditionFailReason } from '../../models';

export class TimeSinceLastInviteBySiteCondition extends BaseCondition {
  constructor(lastInvitationTime: number, options: any, notificationService: NotificationService) {
    super("TimeSinceLastInviteBySiteCondition",notificationService);
    let result: boolean = false;
    if (options.hasOwnProperty('Min')) {
      console.log(`TimeSinceLastInviteBySite :  Configuration parameter Min is ${options.Min} Minutes`);
        if (lastInvitationTime) {
          let diffFromLastVisit = Date.now() - lastInvitationTime;
          console.log(`TimeSinceLastInviteBySite : time of last Invitation By Site is  ${lastInvitationTime} Millisecond`);
          const threshold: number = options.Min * 60 * 1000;
          result = (diffFromLastVisit >= threshold);
          console.log(`TimeSinceLastInviteBySite : difference of time since last Invitation is ${diffFromLastVisit} Millisecond`);
          if (result)
            console.info("TimeSinceLastInviteBySite condition passed!!");
          else
            this.onConditionFail(ConditionFailReason.CriteriaFail, "TimeSinceLastInviteBySite condition failed!!");
        }
        else {
          console.log(`TimeSinceLastInviteBySite :  first invite hence condition is returning true`);
          console.info("TimeSinceLastInviteBySite condition passed!!");
          result = true;
        }
    } else {
      this.onConditionFail(ConditionFailReason.ConfigurationError, `TimeSinceLastInviteBySite :  Configuration error parameter Min missing`);
      console.info("TimeSinceLastInviteBySite condition failed!!");
      result = false;
    }
      this.observable = new Observable(observer => {
        observer.next(result);
       });
    }
}
